export class CABA1031RequestModel {}
